// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__1EbpS","info":"Note_info__12z9y","note":"Note_note__2e9yM","actions":"Note_actions__uqQwq"};